import { PhosphorAirplaneTilt } from "components/Atoms/PhosphorIcon";
import React from "react";
import { getAirportCode } from "shared/utils/flightUtils";
import { TravelHeaderLayout } from "./TravelHeaderLayout";

interface FlightHeaderProps {
  flight: server.dto.Flight
  passengers: server.dto.FlightPassenger[]
}

export const FlightHeader = ({ flight, passengers }: FlightHeaderProps) =>
  <TravelHeaderLayout
    icon={<PhosphorAirplaneTilt iconColor="white" iconSize="large" />}
    departure={{ name: getAirportCode(flight.departure), address: flight.departure.location }}
    arrival={{ name: getAirportCode(flight.arrival), address: flight.arrival.location }}
    dateTime={flight.dateTime}
    detail={flight.flightDesignator}
    durationInMinutes={flight.durationInMinutes}
    artist={flight.artist}
    passengers={passengers.map(p => p.contact.name.fullName)}
  />;
